import { render, staticRenderFns } from "./TransportSettings.vue?vue&type=template&id=1a670d82"
import script from "./TransportSettings.vue?vue&type=script&lang=ts"
export * from "./TransportSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports